<template>
  <div>
    <h4 v-translate="{type: file.meta.meta.document_type || $gettext('Not recognized')}">Document Type: <strong>%{type}</strong></h4>
    <b-alert :show="!!file.meta.meta.reason?.length" variant="warning">
      <h5 v-translate>Reasons</h5>
      <ul class="mb-0 pl-3">
        <li v-for="(reason, index) in file.meta.meta.reason" :key="index">{{reason}}</li>
      </ul>
    </b-alert>
    <div v-if="!showAllFields">
      <b-form-row class="mb-3" v-for="(field, index) in possibleFields" :key="'field-' + index">
        <b-col sm="4" lg="3">
          <label :for="'field' + index" class="col-form-label">{{field[0]}}</label>
        </b-col>
        <b-col>
          <b-form-input :type="inputType(field)" :id="'field' + index" v-model="correctedFields[field[0]]" />
        </b-col>
      </b-form-row>
    </div>
    <div v-else>
      <b-form-row class="mb-3" v-for="(field, index) in allFields" :key="'field-' + index">
        <b-col sm="4" lg="3">
          <label :for="'field' + index" class="col-form-label">{{field[0]}}</label>
        </b-col>
        <b-col>
          <b-form-input :type="inputType(field)" :id="'field' + index" v-model="correctedFields[field[0]]" />
        </b-col>
      </b-form-row>
    </div>
    <b-form-row>
      <b-col class="text-right">
        <b-button size="sm" variant="dark" @click.prevent="showAllFields = !showAllFields">
          <span v-show="!showAllFields" v-translate>
            Show All Fields
          </span>
          <span v-show="showAllFields" v-translate>
            Defined Fields Only
          </span>
        </b-button>
      </b-col>
    </b-form-row>
  </div>
</template>

<script>
import mapValues from 'lodash/mapValues'

export default {
  name: 'EditFieldShippingFilesMeta',
  props: {
    file: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      possibleFields: {},
      correctedFields: {},
      allFields: {},
      showAllFields: false
    }
  },
  computed: {
    correctedFieldsComputed() {
      return mapValues(this.correctedFields, v => v === '' ? null : v)
    }
  },
  methods: {
    inputType(field) {
      const [name, type] = field
      if (type === 'str') return 'text'
      if (type === 'date') {
        const value = this.correctedFields[name]
        const isDateFormat = value === '' || value === null || value === undefined || /^\d{4}-\d{2}-\d{2}$/.test(value)
        return isDateFormat ? 'date' : 'text'
      }
      return 'number'
    }
  },
  watch: {
    correctedFieldsComputed(val) {
      this.file.meta.corrected_fields = val
    },
    showAllFields(val) {
      this.file.meta.meta.allFields = val
    }
  },
  mounted() {
    this.showAllFields = this.file.meta?.meta?.allFields || false
    this.file.meta.meta.applied_by_id = this.profile.id
    this.file.meta.meta.applied_by = {
      id: this.profile.id,
      name: this.profile.name
    }
    if (!this.file.meta.corrected_fields) {
      this.file.meta = { ...this.file.meta, corrected_fields: {} }
    }
    this.possibleFields = Object.entries(this.file.meta?.possible_fields || {})
    this.allFields = Object.entries(this.file.meta?.all_fields || {})
    this.correctedFields = { ...Object.fromEntries(this.possibleFields.map(x => [x[0], null])), ...this.file.meta.extracted_fields, ...this.file.meta.corrected_fields }
  }
}
</script>
